import qs from 'qs'

import { DateTime } from "luxon"

const fields = [
  'title',
  'slug',
  'locale',
  'sortKeyAsc',
  'sortKeyDesc',
]

const sort = ['sortKeyAsc:asc', 'sortKeyDesc:desc', 'title:asc']
const populate = {
  eventCategories: true,
  dateTimeRanges: true,
  coverImage: '*'
}

const startOfYear = DateTime.now().startOf('year').setZone("Europe/Amsterdam").toFormat('yyyy-LL-dd')
const endOfYear = DateTime.now().endOf('year').setZone("Europe/Amsterdam").toFormat('yyyy-LL-dd')

export const queryEventEntriesThumbnailByDateTimeRange = (options: QueryManyOptionsEventEntriesi18n) => {
  const dateTimeStart = options?.dateTimeStart || startOfYear
  const dateTimeEnd = options?.dateTimeEnd || endOfYear

  const query = qs.stringify(
    {
      locale: options?.locale || 'nl-NL',
      pagination: {
        limit: -1,
      },
      sort: sort,
      filters: {
        $or: [
          {
            $and: [
              { sortKeyAsc: { $gte: dateTimeStart } },
              { sortKeyDesc: { $lte: dateTimeEnd } },
            ]
          },
          {
            $and: [
              { sortKeyAsc: { $gte: dateTimeStart } },
              { sortKeyAsc: { $lte: dateTimeEnd } },
              { sortKeyDesc: { $gte: dateTimeEnd } },
            ]
          },
          {
            $and: [
              { sortKeyAsc: { $lte: dateTimeStart } },
              { sortKeyDesc: { $gte: dateTimeStart } },
              { sortKeyDesc: { $lte: dateTimeEnd } },
            ]
          },
          {
            $and: [
              { sortKeyAsc: { $lte: dateTimeStart } },
              { sortKeyDesc: { $gte: dateTimeEnd } }
            ]
          },
        ]
      },
      fields: fields,
      populate: {
        ...populate,
        coverImage: '*',
        localizations: {
          sort: sort,
          fields: fields,
          populate: {
            ...populate,
          }
        },
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `event-entries?${query}`
}
